function calcREM() {
var html = document.documentElement;
var windowWidth = html.clientWidth / 7.5;
html.style.fontSize = (windowWidth > 75 ? 75 : windowWidth) + "px";
}
window.addEventListener("resize", calcREM, false);
calcREM();


// WEBPACK FOOTER //
// ./src/api/rem.js